import OverlayBase from "./OverlayBase";
import {LucideXOctagon} from "lucide-react";
import {ErrorResponse} from "../../../util/fetch";

export default function ErrorOverlay(props: { error: ErrorResponse, hide: () => void }){

    return (
        <OverlayBase hide={props.hide} w="w-[28rem]">
            <h2 className="text-xl font-semibold mb-4 text-red-500"><LucideXOctagon /> An error occurred</h2>
            <div className="space-y-2">
                {props.error.message} ({props.error.code})
            </div>
            <div className="mt-6 flex flex-col items-end">
                <div className="flex justify-end gap-3">
                    <button onClick={props.hide}
                            className="px-4 py-2 bg-primary hover:bg-primary-hover text-white rounded-lg disabled:bg-neutral-600 flex items-center">
                        OK
                    </button>
                </div>
            </div>
        </OverlayBase>
    )
}